import { useAtom } from 'jotai';
import { memo, useEffect } from 'react';
import { marketGoodsListFilterAtom } from './GoodsListFilter.atom';
import { useMarketRoute } from '../../../hooks/useMarketRoute';

const InitializeStore: React.FC<{ children: React.ReactNode }> = props => {
  const routes = useMarketRoute<'MarketHome'>();

  const [value, setValue] = useAtom(marketGoodsListFilterAtom);

  useEffect(() => {
    setValue(prev => ({
      ...prev,
      [routes.params.marketId]: {
        categorySno: routes.params.extras?.category_sno ?? null,
        subCategorySno: null,
        keyword: '',
        sort: routes.params.extras?.order ?? 'RECOMMEND',
        deliveryType: null,
      },
    }));
  }, [
    routes.params.extras?.category_sno,
    routes.params.extras?.order,
    routes.params.marketId,
    setValue,
  ]);

  if (!value[routes.params.marketId]) {
    return null;
  }

  return <>{props.children}</>;
};

export const ScreenStateProvider = memo(
  ({ children }: { children: React.ReactNode }) => {
    return <InitializeStore>{children}</InitializeStore>;
  },
);
